import { render } from "./SectionColumn.vue?vue&type=template&id=0c21ced9"
import script from "./SectionColumn.vue?vue&type=script&lang=js"
export * from "./SectionColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__